import { useEffect } from 'react';

export const ThirdPartyScripts = () => {
    useEffect(() => {
        // Load Botpress only after user interaction or a longer delay
        // to avoid impacting TBT and CPU time during initial load
        let timer;
        let interactionHandler;

        const loadBotpress = () => {
            if (window.botpress_initialized) return;
            window.botpress_initialized = true;

            // Clean up listeners
            if (interactionHandler) {
                ['scroll', 'mousemove', 'touchstart', 'keydown'].forEach(evt => {
                    window.removeEventListener(evt, interactionHandler, { passive: true });
                });
            }
            if (timer) clearTimeout(timer);

            const injectScript = document.createElement('script');
            injectScript.src = "https://cdn.botpress.cloud/webchat/v3.4/inject.js";
            injectScript.async = true;
            injectScript.onload = () => {
                const configScript = document.createElement('script');
                configScript.src = "https://files.bpcontent.cloud/2025/11/23/05/20251123050956-NPN43TOI.js";
                configScript.async = true;
                document.body.appendChild(configScript);
            };
            document.body.appendChild(injectScript);
        };

        // Load on first user interaction (scroll, mousemove, touch, keydown)
        interactionHandler = () => loadBotpress();
        ['scroll', 'mousemove', 'touchstart', 'keydown'].forEach(evt => {
            window.addEventListener(evt, interactionHandler, { once: true, passive: true });
        });

        // Fallback: load after 8 seconds if no interaction
        timer = setTimeout(loadBotpress, 8000);

        return () => {
            clearTimeout(timer);
            ['scroll', 'mousemove', 'touchstart', 'keydown'].forEach(evt => {
                window.removeEventListener(evt, interactionHandler, { passive: true });
            });
        };
    }, []);

    return null;
};

export default ThirdPartyScripts;
